import { FC, useCallback, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ConnectedLayout from "../../components/ConnectedLayout";
import Profil from "./Profil";
import Affichage from "./Affichage";
import Button from "../../components/Button";
import { InfoIcon, MemberIcon, StatsIcon } from "../../assets/img/icons";
import Header from "../../components/Header";
import "./style.css";
import { useMediaQuery } from "@mui/material";
import KYC from "./KYC";

const Account: FC = () => {
    const tabs = [
        { label: "Profil", key: "", icon: MemberIcon },
        { label: "Informations", key: "questions", icon: InfoIcon },
        { label: "Affichage", key: "affichage", icon: StatsIcon },
    ];

    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useMediaQuery("(max-width: 1050px)");

    const activeTab = useMemo(() => {
        const path = location.pathname.split("/").pop();
        if (path === "questions" || path === "affichage" || path === "") {
            return path;
        }
        return "";
    }, [location.pathname]);

    const handleTabChange = useCallback(
        (key: string) => {
            navigate(`/account/${key}`);
        },
        [navigate]
    );

    const renderTabContent = useMemo(() => {
        switch (activeTab) {
            case "":
                return <Profil handleTabChange={handleTabChange} />;
            case "questions":
                return <KYC handleTabChange={handleTabChange} />;
            case "affichage":
                return <Affichage handleTabChange={handleTabChange} />;
            default:
                return null;
        }
    }, [activeTab, handleTabChange]);

    return (
        <ConnectedLayout>
            <Header title="Mon compte" />
            <div className="account_container">
                {!isMobile && (
                    <div className="account_tabs">
                        {tabs.map((tab) => (
                            <Button
                                key={tab.key || "profil"}
                                variant={
                                    activeTab === tab.key
                                        ? "secondary"
                                        : "transparent"
                                }
                                size="medium"
                                Icon={tab.icon}
                                labelOptions={{ align: "left" }}
                                className={`account_tab`}
                                onClick={() => handleTabChange(tab.key)}
                                label={tab.label}
                            />
                        ))}
                    </div>
                )}
                {!isMobile && <div className="account_divider" />}
                <div className="account_tab_content">{renderTabContent}</div>
            </div>
        </ConnectedLayout>
    );
};

export default Account;
